import API from '.';
import { BodDataProps } from '../utils/generalProps';

export const getData = async () => {
  const response = await API.get(`/auth/extra-info`);

  return response.data.data as BodDataProps;
};
